import { useEffect, useState } from 'react'
import { useUserStore } from '@/stores/useUserStore'
import { getAccountId } from '../../../../api/account'
import { fetchRecent } from '@/matteroomTab/Utils'

// MIRA-4417: use the selected timekeeper for requests and account/user cache keys.
export function useRecentMatterScope() {
  const selfId = useUserStore(state => state.selfUser?.id)
  const selectedId = useUserStore(state => state.selectedUser?.id)
  const isDelegationMode = useUserStore(state => state.isDelegationMode)
  const userId = isDelegationMode ? selectedId : selfId
  const ready = !isDelegationMode || selectedId != null
  const delegatorId = userId != null && String(userId) !== String(selfId)
    ? userId
    : undefined
  const scopeKey = `${getAccountId() ?? 'default'}_${userId ?? 'self'}`
  return { delegatorId, scopeKey, ready }
}

// MIRA-4417: hide the previous user's list and discard responses after switching users.
export function useRecentMatters(hasDestination, refreshKey, enabled = true) {
  const { delegatorId, scopeKey, ready } = useRecentMatterScope()
  const [result, setResult] = useState(null)
  useEffect(() => {
    let active = true
    setResult(null)
    if (enabled && ready) {
      fetchRecent(hasDestination, delegatorId)
        .catch(() => [])
        .then(items => {
          if (active) setResult({ scopeKey, items })
        })
    }
    return () => { active = false }
  }, [hasDestination, delegatorId, scopeKey, refreshKey, enabled, ready])
  const current = enabled && ready && result?.scopeKey === scopeKey ? result : null
  return { matters: current?.items ?? EMPTY_MATTERS, loading: enabled && !current, scopeKey }
}

const EMPTY_MATTERS = []
